<!-- src/views/Editor.vue -->
<template>
  <div class="editor-container">
    
    <SelectWorkDirModal/>
    <SelectImgModal/>
    <SelectMoveDirModal/>

    <!-- 左侧导航栏 -->
    <div class="sidebar-wrapper" :style="{ width: sidebarWidth + 'px' }">
      <SidebarNavigation />
    </div>
    <!-- 左侧拖动条 -->
    <div class="resizer" @mousedown="initResize('left')"></div>
    
    <!-- 主内容区域包装器 -->
    <div class="main-content-wrapper">
      <!-- 将计算出的宽度通过 props 传递给 MarkdownEditor -->
      <MarkdownEditor :container-width="mainContentWidth" />
    </div>
    <!-- 主内容区域包装器结束 -->
    
  </div>
</template>

<script>
import SidebarNavigation from '@/components/SidebarNavigation.vue';
import MarkdownEditor from '@/components/MarkdownEditor.vue';
import SelectWorkDirModal from '@/components/SelectWorkDirModal.vue';
import SelectImgModal from '@/components/SelectImgModal.vue';
import SelectMoveDirModal from '@/components/SelectMoveDirModal.vue';

export default {
  name: 'EditorView',
  components: {
    SidebarNavigation,
    MarkdownEditor,
    SelectWorkDirModal,
    SelectImgModal,
    SelectMoveDirModal
  },
  data() {
    return {
      sidebarWidth: 300,
      isResizing: false,
      resizeMode: null,
      startX: 0,
      startSidebarWidth: 0,
    }
  },
  computed: {
    showSelectDirModal(){
      return this.$store.state.showSelectDirModal;
    },

    // 新增：计算主内容区域的宽度
    mainContentWidth() {
      // 获取视口总宽度
      const totalWidth = window.innerWidth;
      // 拖动条宽度
      const resizerWidth = 6;
      // 计算主内容区域宽度 = 总宽度 - 侧边栏宽度 - 拖动条宽度
      return (totalWidth - this.sidebarWidth - resizerWidth) * 0.98 ;
    }
  },
  created(){ // 在页面创建之初检查登录状态
    const token = localStorage.getItem("token");
    const username = localStorage.getItem("username");
    const email = localStorage.getItem("email");
    if (token) {
      this.$store.commit("SET_TOKEN", token);
      this.$store.commit("SET_USERNAME", username);
      this.$store.commit('SET_EMAIL', email);
      this.$store.commit("SET_IS_LOGIN", true);
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleWindowResize);
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.stopResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.stopResize);
  },
  methods: {
    initResize(mode) {
      this.isResizing = true;
      this.resizeMode = mode;
      this.startX = event.clientX;
      this.startSidebarWidth = this.sidebarWidth;
      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'col-resize';
      event.preventDefault();
    },
    onMouseMove(event) {
      if (!this.isResizing) return;
      const dx = event.clientX - this.startX;
      if (this.resizeMode === 'left') {
        const newSidebarWidth = this.startSidebarWidth + dx;
        if (newSidebarWidth >= 200 && newSidebarWidth <= 600) { 
            this.sidebarWidth = newSidebarWidth;
            // 注意：mainContentWidth 是计算属性，会自动更新
        }
      }
    },
    stopResize() {
      this.isResizing = false;
      this.resizeMode = null;
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
    },
    handleWindowResize() {
      // 限制侧边栏最大宽度，mainContentWidth 会随之变化
      if (this.sidebarWidth > window.innerWidth * 0.5) {
          this.sidebarWidth = window.innerWidth * 0.5;
      }
      // 无需手动更新 mainContentWidth，它是计算属性
    },
  }
}
</script>

<style>
/* :root 定义保持不变 */
:root {
  --header-bg-purple-blue-1: #e0e7ff;
  --header-bg-purple-blue-2: #eef2ff;
  --header-bg-purple-blue-3: #ede9fe;
  --header-bg-purple-blue-alpha: rgba(164, 149, 225, 0.95);
}

.editor-container {
  display: flex;
  height: 97.5vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow: hidden;
}

.sidebar-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: 600px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); /* 与整体背景一致或根据设计调整 */
  border-right: 1px solid #e2e8f0;
}

.resizer {
  width: 6px;
  background-color: #e1e5e9;
  cursor: col-resize;
  transition: background-color 0.2s ease;
  position: relative;
  z-index: 10;
  flex-shrink: 0;
}

.resizer:hover {
  background-color: #cbd5e1;
}

.resizer::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 2px;
  height: 30px;
  background-color: #94a3b8;
  border-radius: 1px;
}

/* 新增：主内容区域包装器样式 */
.main-content-wrapper {
  flex: 1; /* 占据剩余空间 */
  height: 100%;
  min-width: 0; /* 防止 flex 项溢出 */
  /* 可以添加 padding 或其他样式 */
  /* padding: 10px; */
  /* background-color: rgba(255, 255, 255, 0.1); 可选：用于调试或视觉分隔 */
  display: flex; /* 确保子元素（MarkdownEditor）能正确填充 */
}

</style>
